export default "__VITE_ASSET__CAcD7qXC__";